<template>
  <div class="contractAdd">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-title">住户信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">乙方：</span>
          </div>
          <el-input v-model="formData.enterpriseName" size="small" style="width: 220px"  />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁地址：</span>
          </div>
          <el-input v-model="formData.address" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">租赁面积：</span>
          </div>
          <el-input v-model="formData.roomInfoArea" size="small" style="width: 220px">
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div style="width: 80px"></div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人：</span>
          </div>
          <el-input v-model="formData.signerName" size="small" style="width: 220px"  />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人手机：</span>
          </div>
          <el-input v-model="formData.signerPhone" size="small" style="width: 220px"  />
        </div>
        <div></div>
        <div style="width: 80px"></div>
      </div>

      <div class="form-title">合同信息</div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同类型：</span>
          </div>
          <el-select v-model="formData.type" placeholder="请选择" size="small" style="width: 220px">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同开始时间：</span>
          </div>
          <el-date-picker v-model="formData.contractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同结束时间：</span>
          </div>
          <el-date-picker v-model="formData.contractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small"></el-date-picker>
        </div>
        <div style="width: 80px"></div>
      </div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同签订时间：</span>
          </div>
          <el-date-picker v-model="formData.contractSignDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">提前付款天数：</span>
          </div>
          <el-input v-model="formData.propertyAheadPayDays" size="small" style="width: 220px">
            <template slot="append">天</template>
          </el-input>
        </div>
        <div></div>
        <div style="width: 80px"></div>
      </div>

      <div class="form-title">账单信息</div>
      <div v-for="(item, index) in formData.otherPayItemDetails">
        <div class="form-line">
          <div>
            <div class="textBox">
              <span class="line-text">账单类型：</span>
            </div>
            <el-select v-model="item.billType" placeholder="请选择" size="small" style="width: 220px">
              <el-option
                v-for="billType in billTypeList"
                :key="billType.name"
                :label="billType.name"
                :value="billType.name">
              </el-option>
            </el-select>
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单开始时间：</span>
            </div>
            <el-date-picker v-model="item.billStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单结束时间：</span>
            </div>
            <el-date-picker v-model="item.billEndTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
          </div>
        </div>
        <div class="form-line">
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">金额：</span>
            </div>
            <el-input v-model="item.payMoney" type="number" size="small" style="width: 220px;vertical-align: top;" v-on:blur="otherItemValueChange(index)">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addOtherItemLine()" v-if="index === formData.otherPayItemDetails.length - 1"></i>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeOtherItemLine(index)" v-if="index > 0"></i>
          </div>
          <div></div>
        </div>

      </div>

      <div class="form-title">其他</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同跟进人：</span>
          </div>
          <el-select v-model="formData.fellowPeopleCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="mini" style="width: 220px">
            <el-option
              v-for="item in yqPersonList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <!--<b class="red">*</b>-->
            <span class="line-text">客户来源：</span>
          </div>
          <el-select v-model="formData.customSource" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in customSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <!--            <b class="red">*</b>-->
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="formData.memo" size="small" style="width: 220px;vertical-align: top;" />
        </div>
        <div style="width: 80px"></div>
      </div>


      <div class="form-btn-box" style="margin: 20px auto 0;">
        <button-confirm @confirm="confirm" value="保存" />
        <button-confirm-next @confirm="confirmAndApproval" value="保存 & 审批" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>


    <div class="approveDialogBox">
      <el-dialog title="合同审批" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">合同摘要</div>
            <el-input type="textarea" :rows="4" placeholder="请输入合同摘要" v-model="digest" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmApprove">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/InvestmentLeasing";
import { nError, nSuccess } from "../../../utils/notice";
import { treeApi } from "../../api/TreeApi";
import { bus } from "../../../utils/bus";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import InputTree from "../../../components/common/inputs/input-tree";

export default {
  components: {
    InputTree,
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "other-contract-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "其他合约",
          name: "other-custom-management"
        },
        {
          value: "合同列表"
        }
      ],
      accountCode: "",
      accountName: "",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      mainTitle: "续租合同",
      subheading: "续租签约住户的合同信息",
      isHousingInUnion: false,
      secDiscountOrSecIncreaseRate: "1",
      leaseAheadPayDayType: "1",
      secValue: "",
      trdValue: "",
      enterpriseLoading: false,
      enterpriseList: [],
      signerNameLoading: false,
      signerNameList: [],
      yqPersonList: [],
      enterpriseCode: "",

      typeList: [
        {
          code: "商户租赁",
          name: "商户租赁"
        },
        {
          code: "场地租赁",
          name: "场地租赁"
        },
        {
          code: "工商地址注册",
          name: "工商地址注册"
        },
        {
          code: "其它",
          name: "其它"
        }
      ],

      customSourceList: [
        {
          code: "自主招商",
          name: "自主招商"
        },
        {
          code: "中介介绍",
          name: "中介介绍"
        }
      ],
      incrementalTimePoint: "",
      incrementalTimePointList: [],
      propertyIncrementalTimePointList: [],

      rentActiveNames: [],
      propertyActiveNames: [],
      rentDetailData: false,
      propertyDetailData: false,
      rentTotal1: 0,
      rentTotal2: 0,
      rentTotal1_1: 0,
      rentTotal2_1: 0,
      changeRentData: false,
      propertyTotal1: 0,
      propertyTotal1_1: 0,
      propertyTotal2: 0,
      propertyTotal2_1: 0,
      changePropertyData: false,
      billTypeList: [],
      formData: {
        enterpriseName: "",
        signerName: "",
        signerPhone: "",
        address: "",
        roomInfoArea: "",

        type: "",
        contractSignDate: "",
        contractStartDate: "",
        contractEndDate: "",
        propertyAheadPayDays: "",

        otherPayItemDetails: [
          {
            billType: '',
            payMoney: "",
            billStartTime: "",
            billEndTime: "",
            feeType: "其他",
            memo: ""
          }
        ],

        fellowPeopleName: "", // 合同跟进人名称
        fellowPeopleCode: "", // 合同跟进人code
        customSource: "",
        memo: ""
      },
      // 审批信息
      approveDialog: false,
      accountList: [],
      contractCode: "",
      approveAccountCode: "",
      digest: ""
    };
  },
  created() {
    this.currentCode = this.$route.params.id;
    this.accountCode = bus.global.accountCode;
    this.accountName = bus.global.accountName;
    this.remoteMethod();
    // this.getYqPersonList()
    this.getOtherBillTypeList()
    this.getOtherContractManagerByCode();
  },
  mounted() {},
  methods: {
    // 获取账单类型列表
    getOtherBillTypeList () {
      this.$axios.post(api.getOtherBillTypeList, {})
        .then(res => {
          this.billTypeList = res.data.data || []
        })
        .catch(errorHandler("获取账单类型失败"));
    },
    getOtherContractManagerByCode() {
      this.$axios
        .get(`${api.getOtherContractManagerByCode}/${this.currentCode}`, {})
        .then(res => {
          this.formData = res.data.data;
          this.formData.otherPayItemDetails = [
            {
              billType: '',
              payMoney: "",
              billStartTime: "",
              billEndTime: "",
              feeType: "其他",
              memo: ""
            }
          ];
          let theLastDay = this.formData.contractEndDate;
          let nextDate = new Date(
            new Date(theLastDay).getTime() + 24 * 60 * 60 * 1000
          ); //前一天
          let nextDateYear = nextDate.getFullYear();
          let nextDateMonth =
            nextDate.getMonth() + 1 < 10
              ? "0" + (nextDate.getMonth() + 1)
              : nextDate.getMonth() + 1;
          let nextDateDay =
            nextDate.getDate() < 10
              ? "0" + nextDate.getDate()
              : nextDate.getDate();

          let afterYear =
            parseInt(this.formData.contractEndDate.slice(0, 4)) +
            1 +
            this.formData.contractEndDate.slice(4, 12);

          this.formData.contractStartDate = `${nextDateYear}-${nextDateMonth}-${nextDateDay}`;
          this.formData.contractEndDate = afterYear;
          let date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let strDate = date.getDate();

          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
          }
          this.formData.contractSignDate = `${year}-${month}-${strDate}`;
        })
        .catch(errorHandler("获取合同失败"));
    },
    toCustomManagement() {
      this.$router.push({
        name: "other-contract-management"
      });
    },

    // 签订人搜索
    enterpriseManagerMethod(query) {
      this.signerNameLoading = true;
      this.$axios
        .post(api.getEnterpriseManagerList, {
          enterpriseCode: this.enterpriseCode,
          searchKey: query || ""
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.signerNameLoading = false;
            let data = res.data.data;
            this.signerNameList = data;
          }
        })
        .catch(errorHandler("获取签订人失败"));
    },

    remoteMethod(query) {
      this.getYqPersonList(query);
    },

    // 获取跟进人列表
    getYqPersonList(searchKey) {
      this.$axios
        .post(api.getYqPersonList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.yqPersonList = data;
          }
        })
        .catch(errorHandler("获取跟进人列表失败"));
    },

    otherItemValueChange(index) {
      if (this.formData.others[index].payMoney) {
        this.formData.others[index].payMoney = parseFloat(
          this.formData.others[index].payMoney
        ).toFixed(2);
      } else {
        this.formData.others[index].payMoney = "0.00";
      }
    },

    // 增加其他费用
    addOtherItemLine() {
      let obj = {
        billType: '',
        payMoney: "",
        billStartTime: "",
        billEndTime: "",
        feeType: "其他",
        memo: ""
      };
      this.formData.otherPayItemDetails.push(obj);
    },

    // 删减其他费用
    removeOtherItemLine(index) {
      this.formData.otherPayItemDetails.splice(index, 1);
    },

    // 获取审批人员列表
    getAccountListByCode() {
      this.$axios
        .post(api.getAccountListByCode, {
          accountCode: this.accountCode
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.length > 0) {
              data.map(v => {
                v._labelName = `${v.name} / ${v.actualName}`;
              });
            }
            this.accountList = data;
          }
        })
        .catch(errorHandler("获取审批人员列表失败"));
    },

    // 保存合同
    confirm() {
      if (!this.formData.enterpriseName) {
        nError("请输入乙方名称");
        return false;
      }
      if (!this.formData.signerName) {
        nError("请输入签订人姓名");
        return false;
      }
      if (!this.formData.signerPhone) {
        nError("请输入签订人电话");
        return false;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name;
        }
      });
      delete this.formData.id;
      this.$axios
        .post(api.saveReletOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("保存成功");
            this.toCustomManagement();
          }
        })
        .catch(errorHandler("保存失败"));
    },
    confirmAndApproval() {
      if (!this.formData.signerName) {
        nError("请选择签订人姓名");
        return false;
      }
      if (!this.formData.fellowPeopleCode) {
        nError("请选择合同跟进人");
        return false;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name;
        }
      });
      delete this.formData.id;
      this.$axios
        .post(api.saveReletOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let contractCode = res.data.data;
            if (contractCode) {
              this.contractCode = contractCode;
              this.approveDialog = true;
              nSuccess("保存成功");
            }
          }
        })
        .catch(errorHandler("保存失败"));
    },
    cancel() {
      this.toCustomManagement();
    },

    // 取消审批
    cancelApprove() {
      this.approveDialog = false;
      this.approveAccountCode = "";
      this.digest = "";
    },

    // 提交审批
    confirmApprove() {
      let obj = {
        contractCode: this.contractCode,
        sponsorAccountCode: this.accountCode,
        sponsorAccountName: this.accountName,
        digest: this.digest,
        approveType: "5"
      };
      this.$axios
        .post(api.submitReletOtherContractApprove, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("提交审批成功");
            this.toCustomManagement();
          }
        })
        .catch(errorHandler("提交审批失败"));
    }
  },
  watch: {
    // 'formData.signerCode': {
    //   handler(newName, oldName) {
    //     this.signerNameList.map(v => {
    //       if (v.code === this.formData.signerCode) {
    //         this.formData.signerName = v.name
    //         this.formData.signerPhone = v.phone
    //       }
    //     })
    //   },
    //   deep: true
    // },
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  margin: 20px 0 10px 0;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 5px 0 10px;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  width: 33%;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 160px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
.contractAdd {
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}

.el-select .el-input .el-select__caret {
  height: 32px;
}
.el-input-group__append {
  padding: 0 5px !important;
  width: auto !important;
}
.el-input-group__prepend {
  padding: 0 5px !important;
  width: auto !important;
}
.discount-line {
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 20px !important;
  }
}

.el-collapse-item__arrow {
  line-height: 48px !important;
}

.contractAdd {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--prefix .el-input__inner {
    padding: 0 0 0 30px;
  }
}

.approveDialogBox {
  text-align: left;
  .el-dialog {
    width: 800px;
  }
  .approveMainBox {
    text-align: center;
  }
  .approve_title {
    width: 120px;
  }
  .approveFlexBox {
    width: 500px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: flex-start;
  }
}

.rent-active {
  .el-range-editor--small {
    .el-range-separator {
      line-height: 30px;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/OtherContractRenewal.vue